// extracted by mini-css-extract-plugin
export default {"error":"MessageError_error__xFZGz","button_close":"MessageError_button_close__IOffa"};